var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-layout',{attrs:{"showSecondMenu":false,"isClazz":_vm.isClazz}},[_c('div',{staticClass:"person-list"},[_c('div',{staticClass:"per-left"},[_c('assessment-menu')],1),_c('div',{staticClass:"per-right"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }